import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router } from "@angular/router";
import { EMPTY, Observable, of } from "rxjs";
import { catchError, filter, switchMap } from "rxjs/operators";
import { OrganizationDetails } from "../../domain/organization";
import { NavigationService } from "../../services/navigation.service";
import { OrganizationService } from "../../services/organization.service";

export const organizationResolver: ResolveFn<OrganizationDetails> = (
  route: ActivatedRouteSnapshot,
): Observable<OrganizationDetails | RedirectCommand> => {
  const router = inject(Router);
  const organizationService = inject(OrganizationService);
  const navigationService = inject(NavigationService);
  const orgIdParam = route.paramMap.get("organizationId");

  if (!orgIdParam) {
    navigationService.navigateTo404();
    return EMPTY;
  }

  const orgId = parseInt(orgIdParam, 10);
  if (isNaN(orgId)) {
    navigationService.navigateTo404();
    return EMPTY;
  }

  return of(orgId).pipe(
    switchMap(() => organizationService.activeOrganization$),
    filter((org): org is OrganizationDetails => org !== null && org.id === orgId),
    catchError((error) => {
      if (error.error?.kind === "organizationTosNotAccepted") {
        return of(
          new RedirectCommand(router.createUrlTree(["/organizations/select"], { queryParams: { tosDialog: orgId } })),
        );
      }

      return of(new RedirectCommand(router.createUrlTree(["/404"]), { skipLocationChange: true }));
    }),
  );
};
